<template>
  <v-expansion-panels v-model="panel" accordion>
    <v-expansion-panel>
      <v-expansion-panel-header disable-icon-rotate>
        Unificar productos

        <template v-slot:actions>
          <v-btn icon v-if="panel === 0" @click.stop="handleDeleteClick">
            <v-icon>mdi-delete</v-icon>
          </v-btn>

          <v-icon v-else>mdi-chevron-down</v-icon>
        </template>
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <!-- Si no hay conflictos mostramos el componente -->
        <ProductosUnificar
          v-if="!hayConflictoDeSucursales.conflicto"
          :productosSeleccionados="productosSeleccionados"
          @unificacionExitosa="emitirUnificacionExitosa"
        />

        <!-- Si hay conflicto mostramos el aviso -->
        <div v-else class="pa-4">
          <v-alert type="info" dense outlined>
            <strong
              >No se puede unificar porque ambos productos están activos en la
              misma sucursal.</strong
            >

            <ul class="mt-2">
              <li
                v-for="(
                  sucursal, index
                ) in hayConflictoDeSucursales.sucursalesConflictivas"
                :key="index"
              >
                <strong>Motivo:</strong> En la sucursal "{{
                  sucursal.sucursalNombre
                }}", ambos productos están en uso.
                <ul>
                  <li>
                    <strong>¿Por qué no se puede?</strong> Cada producto tiene
                    su propio stock, precios, movimientos y configuración
                    contable en esta sucursal. Unificarlos podría mezclar
                    inventarios, generar diferencias en las existencias o
                    afectar las ventas.
                  </li>
                  <li>
                    <strong>¿Qué puedo hacer?</strong><br />
                    Asegúrese de que solo uno de los productos esté activo por
                    sucursal.
                  </li>
                </ul>
              </li>
            </ul>
          </v-alert>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import ProductosUnificar from "@/components/producto/gestion/ProductosUnificar.vue";

export default {
  name: "PanelUnificarProducto",
  components: {
    ProductosUnificar,
  },
  props: {
    productosSeleccionados: {
      type: Array,
      required: true,
    },
  },
  emits: ["unificacionExitosa"],
  data() {
    return {
      panel: 0, // Panel cerrado al inicio
    };
  },
  computed: {
    hayConflictoDeSucursales() {
      const sucursalesUsadas = {};

      this.productosSeleccionados.forEach((producto) => {
        producto.sucursales_compartidas.forEach((sucursalCompartida) => {
          const sucursalId = sucursalCompartida.sucursal.id;
          const sucursalNombre = sucursalCompartida.sucursal.nombre;
          const productoEmpresaId = producto.id;

          if (!sucursalesUsadas[sucursalId]) {
            sucursalesUsadas[sucursalId] = {
              nombre: sucursalNombre,
              productos: [],
            };
          }

          sucursalesUsadas[sucursalId].productos.push({
            productoEmpresaId,
            productoDescripcion: producto.descripcion_comercial,
          });
        });
      });

      const sucursalesConflictivas = Object.entries(sucursalesUsadas)
        .filter(([_, data]) => data.productos.length > 1)
        .map(([sucursalId, data]) => ({
          sucursalId,
          sucursalNombre: data.nombre,
          productos: data.productos,
        }));

      return {
        conflicto: sucursalesConflictivas.length > 0,
        sucursalesConflictivas,
      };
    },
  },
  methods: {
    emitirUnificacionExitosa() {
      this.$emit("unificacionExitosa");
    },
    handleDeleteClick() {
      this.panel = null;
      this.$emit("clear-mode-edition");
      this.$emit("clear-product-selected");
    },
    abrirPanel() {
      this.panel = 0;
    },
    cerrarPanel() {
      this.panel = null;
    },
  },
};
</script>
